import axios from "axios";
import { ApiGeeAuthenticationResponse } from "./types";
import { GEARS_TOKEN, GEARS_TOKEN_EXPIRATION_DATE } from "@constants";

const headers = {
  Accept: "application/json",
};

// Token is minted server-side (gears-backend holds the Apigee app secret); the browser never sees it.
const fetchApigeeToken = async (): Promise<ApiGeeAuthenticationResponse> => {
  const { data } = await axios.get<ApiGeeAuthenticationResponse>(
    `${process.env.REACT_APP_API_URL || ""}/api/v1/apigee-token`,
    { headers }
  );
  return data;
};

export const apiGeeAuthentication =
  async (): Promise<ApiGeeAuthenticationResponse | null> => {
    const pathname_login = window.location.pathname.split("/")[1];

    if (isTokenExpiratedOrNull() && pathname_login !== "login") {
      try {
        const data = await fetchApigeeToken();
        sessionStorage.setItem(GEARS_TOKEN_EXPIRATION_DATE, data.date_created);
        sessionStorage.setItem(GEARS_TOKEN, data.token);

        window.location.href = `/login/r${window.location.pathname}`;
        throw new axios.Cancel("Operation canceled by the user.");
      } catch (error) {
        throw error;
      }
    } else if (pathname_login === "login") {
      try {
        const data = await fetchApigeeToken();
        sessionStorage.setItem(GEARS_TOKEN_EXPIRATION_DATE, data.date_created);
        sessionStorage.setItem(GEARS_TOKEN, data.token);

        return data;
      } catch (error) {
        throw error;
      }
    }
    return null;
  };

export function isTokenExpiratedOrNull(): boolean {
  const tokenSessionExpirationDate = sessionStorage.getItem(
    GEARS_TOKEN_EXPIRATION_DATE
  );
  const tokenGearsSession = sessionStorage.getItem(GEARS_TOKEN);

  if (tokenSessionExpirationDate === null || tokenGearsSession === null) {
    return true;
  } else {
    const expireDate = new Date(tokenSessionExpirationDate);
    expireDate.setHours(expireDate.getHours() + 1);

    const actualDate = new Date();
    return actualDate > expireDate;
  }
}
